// Debug helper to track transition errors
export const debugTransition = (componentName, operation) => {
  console.log(`🔍 TRANSITION DEBUG: ${componentName} - ${operation}`);
  
  // Override console.error to catch transition errors
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0] && args[0].toString().includes('scrollTop')) {
      console.log(`🚨 SCROLLTOP ERROR in ${componentName}:`, args);
      console.trace('Call stack:');
    }
    originalError.apply(console, args);
  };
};

// Add global error listener for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.toString().includes('scrollTop')) {
    console.error('🚨 UNHANDLED SCROLLTOP ERROR:', event.reason);
    console.trace('Promise rejection stack:');
  }
});

// Add global error listener
window.addEventListener('error', (event) => {
  if (event.error && event.error.toString().includes('scrollTop')) {
    console.error('🚨 GLOBAL SCROLLTOP ERROR:', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: event.error,
      stack: event.error.stack
    });
  }
});
